export const USER_ROLE_ENUM = Object.freeze({
    CLIENT : 'client',
    TECH: 'tech',
    SOLICITANT: 'solicitant',
    SCM: 'scm',
  })